import React, { useState, useEffect } from "react";
import InputComponent from "./InputComponent/InputComponent";
import DatasheetComponent from "./DatasheetComponent/datasheetComponent"
import axios from "axios"; // make sure axios is installed
import { Grid, Paper, Typography, Stack, Box } from "@mui/material";
import Results from "./ResultsComponent/ResultsComponent"
import CalculationSheet from "./CalculationComponent/CalculationComponent"
import Report from "./ReportComponent/reportComponent";
import OpenCalculation from "./OpenCalculation/OpenCalculation";
import SaveCalculation from "./SaveCalculation/SaveCalculation"
import Header from "../HomePage/components/header/header";
import Footer from "../HomePage/components/footer/footer";


function App() {
  const [inputData, setInputData] = useState({});
  const [results, setResults] = useState({});
  const [inputDataSave, setInputDataSave] = useState({});

  const handleInputChange = (data) => {
    if (inputDataSave.loadCurrent !== undefined) {
    setInputDataSave({})}
    setInputData(data);

  };

  const handleOpenCalculation = (data) => {
    setInputData(data);
    setInputDataSave(data);
  };



    useEffect(() => {
    const fetchCableSizeCalculation = async () => {
      if (Object.keys(inputData).length === 0) return; // prevent empty calls

      try {
        const response = await axios.post("https://app.wiringmaster.org/HVcablesizecalculator", inputData); // Update URL as needed
        setResults(response.data);
        console.log("Cable size calculation result:", response.data); // Debug log
      } catch (error) {
    setResults({});
        console.error("Error fetching cable size calculation:", error);
      }
    };

    fetchCableSizeCalculation();
  }, [inputData]);

  return (
    <div>
      <Header/>
      <Grid container spacing={2} justifyContent="center" style={{ padding: "1rem" }}>
  <Grid item xs={12} sm={12} md={5}>
    <Paper
      elevation={6}
      style={{
        padding: "1rem",
        borderRadius: "20px",
        background: "#ffffff",
        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
      }}
    >
      <Grid container spacing={2}>
        {results.activeResults && inputData.loadCurrent && (
          <Grid item xs={4}>
            <Report
              key={JSON.stringify(inputData)}
              results={results}
              inputData={inputData}
            />
          </Grid>
        )}
        <Grid item xs={4}>
          <SaveCalculation inputData={inputData} />
        </Grid>
                <Grid item xs={4}>
          <OpenCalculation onOpenCalculation={handleOpenCalculation} />
        </Grid>
      </Grid>
    </Paper>
  </Grid>
</Grid>
    
     <Results results={results} inputData={inputData}  />
     <InputComponent handleInputChange={handleInputChange} inputDataSave={inputDataSave} />
     <DatasheetComponent inputData={inputData} />
     <CalculationSheet results={results} inputData={inputData} />
    


     <Footer/>     
    </div>
    
  );
}

export default App;
